/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.center[_ngcontent-%COMP%]{text-align:center}.margintop[_ngcontent-%COMP%]{margin-top:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/home/home.component.css.shim.ngstyle.js.pre-build-optimizer.js